
export default {
  alias: "/",
  path: "/home",
  name: "Home",
  component: () => import("@/presentation/views/Home/Home.vue"),
  redirect: { name: "HomeGeneral" },
  meta: { requiresAuth: true, allowPermission: 'dashboard:view' },
  general: {
    path: "geral",
    name: "HomeGeneral",
    component: () =>
      import("@/presentation/views/Home/HomeGeneral/HomeGeneral.vue"),
  },
  monitoring: {
    path: "monitoramento",
    name: "HomeMonitoring",
    component: () =>
      import("@/presentation/views/Home/HomeMonitoring/HomeMonitoring.vue"),
  },
} as const